import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
const videoMediaSchema = Joi.object({
  video: mediaUrlSchema.allow('', null),
  thumbnail: mediaUrlSchema.allow('', null)
}).unknown(true);
export default videoMediaSchema;